import Vue from 'vue';
import warehouseTransformer from './../../transformers/warehouse';

const success = (resolve, response) => {
  resolve(warehouseTransformer.fetch(response.data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(warehouseTransformer.fetch(errors));
};

export default warehouse => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/warehouses', warehouse)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/warehouse/store.js